import { render, staticRenderFns } from "./BSActions.vue?vue&type=template&id=b59824b8&"
import script from "./BSActions.vue?vue&type=script&lang=js&"
export * from "./BSActions.vue?vue&type=script&lang=js&"
import style0 from "./BSActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports